<template>
  <v-container class="grey lighten-5">
    <div class="my-3">
    <v-btn icon :to="{ path: '/' }">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 px-3">ENEOS様向け分析依頼登録</span>
    </div>
    <v-form ref="mymachine_form">
      <v-card outlined flat class="mb-1 pb-1">
      <v-row dense class="pa-2 pt-2 pb-0">
        <v-col dense cols="3" md='3'>
          <v-text-field
            v-model="CustomerOrderNumber"
            outlined
            dense
            counter=8
            label="試験依頼番号（注文番号）"
            @input="$v.CustomerOrderNumber.$touch()"
            @blur="$v.CustomerOrderNumber.$touch()"
            :error-messages="CustomerOrderNumberErrors"
          ></v-text-field>
        </v-col>
        <v-col dense cols="6" md='6'>
          <v-select v-model="selectedOffice" label="事業所"
            :items="officeList"
            item-value="OfficeID"
            item-text="Name"
            dense
            outlined
            @change="changeOffice"
            @input="$v.selectedOffice.$touch()"
            @blur="$v.selectedOffice.$touch()"
            :error-messages="selectedOfficeErrors"
          >
            <template slot='selection' slot-scope='data'>
              {{ data.item.Name }}
            </template>
            <template slot="item" slot-scope="data">
              <!-- HTML that describe how select should render items when the select is open -->
              {{ data.item.Name }}
            </template>
          </v-select>
        </v-col>
        <v-col dense cols="3" md='3'>
          <v-menu
            v-model="applicationDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            bottom
            :offset-y=true
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="applicationDate"
                label="分析依頼日"
                v-bind="attrs"
                v-on="on"
                clearable
                outlined
                dense
                @input="$v.applicationDate.$touch()"
                @blur="$v.applicationDate.$touch()"
                :error-messages="applicationDateErrors"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="applicationDate"
              @input="applicationDatePicker = false"
              locale="ja"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
<!--
      <v-row dense class="pa-2 pt-0 pb-0">
        <v-col dense cols="6" md='6'>
          <v-text-field
            v-model="RepCompany"
            outlined
            dense
            counter=30
            label="証明書宛名（得意先名）"
            @input="$v.RepCompany.$touch()"
            @blur="$v.RepCompany.$touch()"
            :error-messages="RepCompanyErrors"
          ></v-text-field>
        </v-col>
      </v-row>
-->
      </v-card>

      <v-card outlined flat class="mb-1">
        <v-card-actions>
          <v-btn
            icon
            @click="showSearch = !showSearch"
          >
            <v-icon>{{ showSearch ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
          定期登録番号でマイ機器を検索
        </v-card-actions>
        <v-expand-transition>
          <div v-show="showSearch">
            <v-text-field
              v-model="search"
              class="px-2 mb-0 mt-2"
              prepend-inner-icon="mdi-magnify"
              placeholder="定期登録番号などで検索"
              dense
              filled
              @change="searchMachie"
            ></v-text-field>
<!--
              :page.sync="page"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
-->
            <v-data-table
              :headers="headers"
              :items="machines"
              :search="search"
              :items-per-page=10
              :sort-by="['CustomerMachineID']"
              :sort-desc="[false]"
              :loading="loading"
              class="elevation-1 px-2 mb-0 mt-0"
              loading-text="読込中"
              no-data-text="データがありません。"                    
              no-results-text="検索条件に該当するデータがありません。"                  
              hide-default-footer
              dense
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-tooltip left color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on"
                      fab
                      x-small
                      elevation="1"
                      color="amber"
                      @click="addSample(item)"
                      class="mx-2 caption">
                      <v-icon 
                        small 
                        >mdi-cup-water</v-icon>
                    </v-btn>
                  </template>
                  <span>サンプルを追加します</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </div>
        </v-expand-transition>
      </v-card>



      <v-card outlined flat class="mt-0 mb-2 pb-6">
        <v-card-title class="pt-2 pl-2 pb-2">
          分析依頼サンプル一覧
        </v-card-title>
        <v-data-table
          :headers="samplesHeaders"
          :items="selectedSamples"
          v-model="selectedSamples"
          :page.sync="page"
          :items-per-page=100
          :loading="loading"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="分析依頼サンプルを追加して下さい。"                    
          hide-default-footer
          dense
          show-expand
          :expanded="selectedSamples"
          @page-count="pageCount = $event"
          @input="$v.selectedSamples.$touch()"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-chip v-show="item.AnalizeItemNameJSON" v-for="a of item.AnalizeItemNameJSON" v-bind:key="a.name" class="ml-4 mt-1 mb-1 white--text" small color="grey darken-2">{{ a.value }} {{ a.name }}</v-chip>
            </td>
          </template>

          <template v-slot:[`item.OilUsageTime`]="{ item }">
            <v-edit-dialog
              :return-value.sync="item.OilUsageTime"
              large
              save-text="設定"
              cancel-text="キャンセル"
            >
              {{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}
              <template v-slot:input>
                <v-text-field
                  v-model="item.OilUsageTime"
                  label="オイル使用時間"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:[`item.SampleID`]="{ item }">
            <v-edit-dialog
              :return-value.sync="item.SampleID"
              large
              save-text="設定"
              cancel-text="キャンセル"
            >
              {{ numSampleID(item.SampleID) }}
              <template v-slot:input>
                <v-text-field
                  v-model="item.SampleID"
                  label="サンプル番号"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:[`item.SamplingAt`]="{ item }">
            <v-edit-dialog
              :return-value.sync="item.SamplingAt"
              large
              save-text="設定"
              cancel-text="キャンセル"
            >
              {{ item.SamplingAt }}
              <template v-slot:input>
<!--
                <v-text-field
                  v-model="item.SamplingAt"
                  :rules="[max25chars]"
                  label="採取日"
                  single-line
                  counter
                ></v-text-field>
-->
              <v-date-picker
                v-model="item.SamplingAt"
                @input="SamplingAtPicker = false"
                locale="ja"
              ></v-date-picker>
              </template>
            </v-edit-dialog>
          </template>

          <template v-slot:[`item.id`]="{ item }">
            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on"
                  fab
                  x-small
                  elevation="1"
                  color="amber"
                  @click="delSample(item)"
                  class="caption">
                  <v-icon 
                    middium
                    >mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>サンプルを削除します</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <span class="px-3 red--text caption" v-if ="isSelected">1つ以上の分析サンプルを選択してください</span>
        <span class="px-3 red--text caption" v-if ="noSaplingAt">採取日が設定されていないサンプルがあります。採取日を設定してください。</span>
        <span class="px-3 red--text caption" v-if ="invalidOilUsageTimeValue">オイル使用時間を半角数字で入力して下さい。</span>

      </v-card>

<!--
          @click="isConfirmed = true" 
-->

      <v-card flat class="mt-5 mb-2">
        <v-tooltip top color="grey darken-2">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              rounded 
              block 
              color="amber darken-1" 
              @click="validation()"
              data-createApplication>
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              依頼内容を確認する
            </v-btn>
          </template>
          <span>クリックすると、依頼内容の確認画面が開きます</span>
        </v-tooltip>
      </v-card>

    </v-form>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
            ご依頼内容をご確認ください
          </v-card-title>
          <v-card-text> 下記の申請内容をご確認のうえ「分析診断を依頼する」ボタンをクリックしてください</v-card-text>

          <v-card outlined flat class="mb-3 pb-0">
            <div class="teal darken-1 pa-2 mb-1 white--text">案件の情報</div>
            <v-row dense class="pa-2">
              <v-col dense cols="12" md='3'>
                <v-text-field v-model="CustomerOrderNumber" label="試験依頼番号" dense readonly class="pb-0"></v-text-field>
              </v-col>
              <v-col dense cols="12" md='6'>
                <v-text-field v-model="selectedOfficeName" label="事業所" dense readonly class="pb-0"></v-text-field>
              </v-col>
              <v-col dense cols="12" md='3'>
                <v-text-field v-model="applicationDate" label="分析依頼日" dense readonly class="pb-0"></v-text-field>
              </v-col>
              <v-col dense cols="12" md='12'>
                <v-text-field v-model="RepCompany" label="得意先名（報告書宛名）" dense readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card>

<!--
          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">報告書の送付先</div>
            <v-row dense class="pa-1">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="DelvCompany" label="会社名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">                    
                  <v-text-field v-model="DelvOffice" label="事業者名" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">                    
                  <v-text-field v-model="DelvDept" label="部署名" dense readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="1" md='1' sm='1' xs="3">
                  <v-text-field v-model="DelvZip" label="郵便番号" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="7
              " md='5' sm='5' xs="9">
                  <v-text-field v-model="DelvAddress" label="ご住所" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="2" md='3' sm='3' xs="6">
                  <v-text-field v-model="DelvTel" label="お電話番号" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='3' sm='3' xs="6">
                  <v-text-field v-model="DelvFAX" label="FAX番号" dense readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                  <v-text-field v-model="DelvPIC" label="ご担当者様名" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                  <v-text-field v-model="Delvemail" label="メールアドレス" dense readonly></v-text-field>
              </v-col>
            </v-row>                  
          </v-card>

          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">報告書の宛先</div>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                <v-text-field v-model="RepCompany" label="会社名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="3" md='3' sm='3' xs="12">
                <v-text-field v-model="RepOffice" label="事業所名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="3" md='3' sm='3' xs="12">
                <v-text-field v-model="RepDept" label="部署名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                <v-text-field v-model="RepPIC" label="ご担当者様名" dense readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          
          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">請求書／納品明細書の送付先</div>
              <v-row dense class="pa-2">
                <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="PayCompany" label="会社名" readonly dense></v-text-field>
                </v-col>
                <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="PayOffice" label="事業所名" readonly dense></v-text-field>
                </v-col>
                <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="PayDept" label="部署名" readonly dense></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="pa-2">
                <v-col cols="1"  lg="1" md='1' sm='1' xs="4">
                  <v-text-field v-model="PayZip" label="郵便番号" readonly dense></v-text-field>
                </v-col>
                <v-col cols="11"  lg="7" md='7' sm='7' xs="8">
                  <v-text-field v-model="PayAddress" label="ご住所" readonly dense></v-text-field>
                </v-col>
                <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                  <v-text-field v-model="PayTel" label="お電話番号" readonly dense></v-text-field>
                </v-col>
                <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                  <v-text-field v-model="PayFAX" label="FAX番号" readonly dense></v-text-field>
                </v-col>
              </v-row>

              <v-row dense class="pa-2">
                <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="PayPIC" label="ご担当者様" readonly dense></v-text-field>
                </v-col>
              </v-row>
            </v-card>
-->


            <v-card outlined flat class="mb-3">
              <div class="teal darken-1 pa-2 mt-0 mb-1 white--text">分析サンプル</div>
              <v-row class="pa-2 mt-0" dense>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>


                  <v-data-table
                    :headers="confirmSamplesHeaders"
                    :items="selectedSamples"
                    v-model="selectedSamples"
                    :sort-by="['SampleID']"
                    :sort-desc="[false]"
                    :page.sync="page"
                    :items-per-page=100
                    :loading="loading"
                    class="elevation-1"
                    loading-text="読込中"
                    no-data-text="分析依頼サンプルを追加して下さい。"                    
                    hide-default-footer
                    dense
                    show-expand
                    :expanded="selectedSamples"
                    @page-count="pageCount = $event"
                    @input="$v.selectedSamples.$touch()"
                  >
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-chip v-show="item.AnalizeItemNameJSON" v-for="a of item.AnalizeItemNameJSON" v-bind:key="a.name" class="ml-4 mt-1 mb-1 black--text" small color="grey lighten-1">{{ a.value }} {{ a.name }}</v-chip>
                      </td>
                    </template>
                    <template v-slot:[`item.OilUsageTime`]="{ item }">
                        {{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}
                    </template>
                    <template v-slot:[`item.CustomerOrderNumber`]="{ item }">
                      {{item.CustomerOrderNumber}}-{{ numSampleID(item.SampleID) }}
                    </template>
                  </v-data-table>

<!--
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="body-5" width="10%">試料番号</th>
                          <th class="body-5" width="10%">定期登録番号</th>
                          <th class="body-5" width="15%">使用機器名</th>
                          <th class="body-5" width="15%">オイルメーカー</th>
                          <th class="body-5" width="15%">オイル名</th>
                          <th class="body-5" width="10%">採取日</th>
                          <th class="body-5" width="15%">オイル使用時間</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr dense v-for="item of selectedSamples" v-bind:key="item.id">
                          <td class="body-5">
                            {{ item.CustomerOrderNumber}}-{{ numSampleID(item.SampleID) }}
                          <td class="body-5">
                            {{ item.CustomerMachineID }}
                          </td>
                          <td class="body-5">
                              {{ item.Name }}
                          </td>
                          <td class="body-5">
                              {{ item.OilmakerID }}
                          </td>
                          <td class="body-5">
                              {{ item.OilModelNumber }}
                          </td>
                          <td class="body-5">
                              {{ item.SamplingAt }}
                          </td>
                          <td class="body-5">
                              {{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
-->

                </v-col>
              </v-row>
          </v-card>

        <v-card-actions>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn 
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="createApplication()" 
              :disabled="processing"
              data-createApplication 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  分析診断を依頼する
              </v-btn> 
            </template>
            <span>依頼を登録します</span>
          </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { fetchAllMachineByOffice } from '../utils/utils'
import { createApplication,  } from "../graphql/mutations"
import { createSample } from "../graphql/mutations"
import { officeByCompany, } from '../graphql/queries'
import { companyByKey, } from '../graphql/queries'
import { sortedAnalizeSetByType, } from '../graphql/queries'
import { sortedAnalizeItemByType, } from '../graphql/queries'
import { analizeItemByCompany, } from '../graphql/queries'
import { analizeTypeByGroup, } from '../graphql/queries'
import { analizeTypeGroupByCategory, } from '../graphql/queries'

import validations from '../utils/validations.js'
import { required, maxLength } from 'vuelidate/lib/validators'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successApplicationDialog_JXTG.vue"
import { helpers } from 'vuelidate/lib/validators'
import generateUuid  from '../utils/generateUuid.js'
//const alpha_dash = helpers.regex('alpha_dash', /^[a-zA-Z0-9_ -]*$/)
const eneosOrderNumber = helpers.regex('eneosOrderNumber', /^[0-9]{2}[A-Z]{2}[0-9]{3,4}$/)


/*function requiredRepPICID (vaslue, vm) {
  console.log("vm.CustomRepCheckbox", vm.CustomRepCheckbox)
  console.log("vm.RepPICID", vm.RepPICID)
  if (!vm.CustomRepCheckbox) {
    if(!vm.RepPICID) {
      console.log("return", false)
      return false
    }
  }
    console.log("return", true)
  return true

}
*/
export default {

  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyDirty&&!this.isPageMove) {
      let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
       next()
    }
  },


  mixins:[validations, generateUuid],
  head: {
    title: { inner: '分析・診断サービス依頼'},
  },
  components: {
    sucDialog: entSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
  },  
  data() {
    return {
      targetCompanyID: "0000000881",
      analizeTypeList: [],
      analizeSetList: [],
      analizeItemList: [],

      selectedSamples: [],

      CustomerOrderNumber: "",
      RepCompany: "",

      applicationDate: "",
      applicationDatePicker: false,
      loading: false,

      machines: [],
      selectedOffice: "",
      selectedOfficeName: "",
      samples: [],
      SamplingAtPicker: false,
      showSearch: true,

      officeList: [],

      search: '',

      isSelected: false,
      noSaplingAt: false,
      invalidOilUsageTimeValue: false,
      isConfirmed: false,
      isPageMove: false,
      processing: false,

      successUrl: '/staffpage',
      successText: '分析依頼を登録しました。',
      valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
      failureUrl: '/',
      page: 1,
      pageCount: 0,
      headers: [
        {
          text: 'マイ機器ＩＤ(定期登録番号)',
          value: 'CustomerMachineID',
          class: "teal darken-1 white--text",
          width: '20%'
        },
        {
          text: 'マイ機器名',
          align: 'start',
          value: 'Name',
          class: "teal darken-1 white--text",
          width: '20%'
        },
        {
          text: 'オイルメーカー',
          align: 'start',
          value: 'OilmakerID',
          class: "teal darken-1 white--text",
          width: '25%',
          sortable: false,
        },
        {
          text: 'オイル名',
          align: 'start',
          value: 'OilModelNumber',
          class: "teal darken-1 white--text",
          width: '25%',
          sortable: false,
        },
        {
          text: '追加',
          value: 'id',
          class: "teal darken-1 white--text",
          width: '10%',
          sortable: false,
        },
      ],

      samplesHeaders: [
        {
          text: '試験依頼番号',
          value: 'CustomerOrderNumber',
          class: "grey darken-2 white--text",
          width: '10%',
          sortable: false,
        },
        {
          text: '試料番号',
          value: 'SampleID',
          class: "amber darken-1 black--text",
          width: '5%'
        },
        {
          text: '定期登録番号',
          value: 'CustomerMachineID',
          class: "grey darken-2 white--text",
          width: '12%'
        },
        {
          text: '使用機器名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '15%',
          sortable: false,
        },
        {
          text: 'オイルメーカー',
          align: 'start',
          value: 'OilmakerID',
          class: "grey darken-2 white--text",
          width: '12%',
          sortable: false,
        },
        {
          text: 'オイル名',
          align: 'start',
          value: 'OilModelNumber',
          class: "grey darken-2 white--text",
          width: '15%',
          sortable: false,
        },
        {
          text: '採取日',
          align: 'start',
          value: 'SamplingAt',
          class: "amber darken-1 black--text",
          width: '13%'
        },
        {
          text: 'オイル使用時間',
          align: 'end',
          value: 'OilUsageTime',
          class: "amber darken-1 black--text",
          width: '10%',
          sortable: false,
        },
        {
          text: '削除',
          value: 'id',
          align: 'center',
          class: "grey darken-2 white--text",
          width: '6%',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          class: "grey darken-2 white--text",
          width: '2%',
          sortable: false,
        },
      ],
      confirmSamplesHeaders: [
        {
          text: '試料番号',
          value: 'CustomerOrderNumber',
          class: "white--black",
          width: '13%',
          sortable: false,
        },
        {
          text: '定期登録番号',
          value: 'CustomerMachineID',
          class: "white--black",
          width: '12%'
        },
        {
          text: '使用機器名',
          align: 'start',
          value: 'Name',
          class: "white--black",
          width: '18%',
          sortable: false,
        },
        {
          text: 'オイルメーカー',
          align: 'start',
          value: 'OilmakerID',
          class: "white--black",
          width: '15%',
          sortable: false,
        },
        {
          text: 'オイル名',
          align: 'start',
          value: 'OilModelNumber',
          class: "white--black",
          width: '15%',
          sortable: false,
        },
        {
          text: '採取日',
          align: 'start',
          value: 'SamplingAt',
          class: "white--black",
          width: '12%'
        },
        {
          text: 'オイル使用時間',
          align: 'end',
          value: 'OilUsageTime',
          class: "white--black",
          width: '13%',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
          class: "white--black",
          width: '2%',
          sortable: false,
        },
      ],


      editedIndex: -1,
      editedItem: {
        DeliveryPeriod: '',
      },      
//      agreement_url: process.env.VUE_APP_AGREE_URL,
      agreement_url: "https://www.japan-analysts.com/downloads/terms/"
    }
  },
  validations: {
    CustomerOrderNumber: { required, eneosOrderNumber, maxLength: maxLength(8) },
    selectedOffice: { required, },
    applicationDate: { required, },
    selectedSamples: { required, },
//    RepCompany: { required, },
  },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    }
  },
  computed: {
    CustomerOrderNumberErrors () { return this.defaultMessage(this.$v.CustomerOrderNumber) },
    selectedOfficeErrors () { return this.defaultMessage(this.$v.selectedOffice) },
    applicationDateErrors () { return this.defaultMessage(this.$v.applicationDate) },
//    RepCompanyErrors () { return this.defaultMessage(this.$v.RepCompany) },
  },
  mounted: async function () {
    let _jxtgList = await API.graphql(graphqlOperation(companyByKey, {CompanyID: this.targetCompanyID}))
    let companyJXTG = _jxtgList.data.companyByKey.items[0]

    let _jxtgOfficeList = await API.graphql(graphqlOperation(officeByCompany, {CompanyID: this.targetCompanyID}))
    this.officeList = _jxtgOfficeList.data.officeByCompany.items
    // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
    // 各マスタの名称で上書きする
    for (const office of this.officeList) {
        office["CompanyName"] = companyJXTG.Name
        office["PaymentOfficeID"] = companyJXTG.PaymentOfficeID
    }

    let analizeTypeGroup = await API.graphql(graphqlOperation(analizeTypeGroupByCategory, {AnalizeTypeCategory: 'JXTG'}))
    let analizeTypeGroupList = analizeTypeGroup.data.analizeTypeGroupByCategory.items
    let analizeTypeList = []
    let analizeTypeListArray = []
    //----------------------------------------
    // 分析区分（潤滑油、燃料 etx）               
    for (var group of analizeTypeGroupList) {
        let analizeType = await API.graphql(graphqlOperation(analizeTypeByGroup, {AnalizeTypeGroup: group.Value}))
        let analizeTypeListItem = {AnalizeTypeGroup: group.Value, AnalizeTypes: analizeType.data.analizeTypeByGroup.items}
        analizeTypeList.push(analizeTypeListItem)
        for(var a of analizeType.data.analizeTypeByGroup.items) {
            analizeTypeListArray.push(a)
        }
    }
//    this.$store.commit('setAnalizeTypeList',analizeTypeList )
    this.analizeTypeList = analizeTypeList

    //----------------------------------------
    // 得意先（企業）別分析項目(全部取得)
    let analizeItem4Com = await API.graphql(graphqlOperation(analizeItemByCompany, {CompanyID: this.targetCompanyID} ))
    let _analizeItem4Com = analizeItem4Com.data.analizeItemByCompany.items

    //----------------------------------------
    // 分析区分毎の分析セットと分析項目              
    let analizeSetList = []
    let analizeItemList = []
//    let standardValueList = []
    for (var type of analizeTypeListArray) {
        //----------------------------------------
        // 分析セット
        //  共通 Company=0000000000 
        //  企業別特別セット Company=企業コード
        let setFilter = {
            or: [
            { Company: {eq: "0000000000"} },
            { Company: {eq: this.targetCompanyID} },
            ]
        }
        let analizeSet = await API.graphql(graphqlOperation(sortedAnalizeSetByType, {AnalizeType: type.Value, filter:setFilter, limit:300}))
        let _analizeSet = analizeSet.data.sortedAnalizeSetByType.items
        let analizeSetListItem = {AnalizeType: type.Value, AnalizeSets: _analizeSet}
        analizeSetList.push(analizeSetListItem)

        //----------------------------------------
        // 分析項目
        let analizeItem = await API.graphql(graphqlOperation(sortedAnalizeItemByType, {AnalizeType: type.Value, limit:300} ))
        let _analizeItem = analizeItem.data.sortedAnalizeItemByType.items
        for (var item4com of _analizeItem4Com) {
            // 得意先（企業）別分析項目で上書き
            var aaa = _analizeItem.filter(item => item.Value  == item4com.Value)
            if(aaa[0]) {
                aaa[0].Price = item4com.Price
                if(item4com.CustomText) {
                    aaa[0].Text = item4com.CustomText
                }
            }
        }

        let analizeItemListItem = {AnalizeType: type.Value, AnalizeItems: _analizeItem}
        analizeItemList.push(analizeItemListItem)

        //----------------------------------------
        // 分析区分毎の分析規格のみ
//        let standardValue = standardValueAllType.filter(item => item.AnalizeType == type.Value)
//        let standardValueListItem = {AnalizeType: type.Value, standardValues: standardValue}
//        standardValueList.push(standardValueListItem)
    }
//  this.$store.commit('setAnalizeSetList', analizeSetList )
//  this.$store.commit('setAnalizeItemList', analizeItemList )
    this.analizeSetList = analizeSetList
    this.analizeItemList = analizeItemList

  },
  methods: {
    openAgreement() {
        window.open(this.agreement_url, '_blank')
    },
    numSampleID (sampleid) {
      return ( '000' + Number(sampleid) ).slice( -3 );
    },
    changeOffice: async function () {
        const Office = this.officeList.filter(item => item.OfficeID  == this.selectedOffice)
        this.selectedOfficeName = Office[0].Name
        this.searchMachie()
    },
    addSample(sample) {

      this.$v.CustomerOrderNumber.$touch()
      if (this.$v.CustomerOrderNumber.$invalid) {
        return
      }

      console.log("machine memo", sample.MachineMemo)
      const memos = sample.MachineMemo.split('\n');
      for (var memo of memos) {
        if(memo.indexOf("得意先名：") != -1) {
          console.log("得意先名", memo.substr(5))
          this.RepCompany = memo.substr(5)
        }else if(memo.indexOf("需要家名：") != -1)
        console.log("需要家名",  memo.substr(5))
      }

      //※引数sampleは実際はmachineのレコード
      //Application.idの値を自己生成 形式は4×4
      let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
      const _sample = {}
      _sample["id"] = uuid
      _sample["CustomerOrderNumber"] = this.CustomerOrderNumber
      _sample["SampleID"] = this.selectedSamples.length + 1
      _sample["CustomerMachineID"] = sample.CustomerMachineID
      _sample["MachineID"] = sample.id
      _sample["Name"] = sample.Name
      _sample["OilmakerID"] = sample.OilmakerID
      _sample["OilModelNumber"] = sample.OilModelNumber
      _sample["OilTypeCategory"] = sample.OilTypeCategory
      _sample["OilTypeCategoryText"] = sample.OilTypeCategoryText
      _sample["OilType"] = sample.OilType
      _sample["OilTypeText"] = sample.OilTypeText
      _sample["SamplingAt"] = ""
      // ENEOSサンプルは機器使用時間、オイル使用時間に同じ値を設定
      _sample["OperatingTime"] = null
      _sample["OperatingTimeUnit"] = "10000002"
      _sample["OperatingTimeUnitText"] = "Hr"
      // ENEOSサンプルは時間（Hr）固定
      _sample["OilUsageTime"] = null
      _sample["OilUsageTimeUnit"] = "10000002"
      _sample["OilUsageTimeUnitText"] = "Hr"
      _sample["isHazardousMaterials"] = sample.isHazardousMaterials
      _sample["HazardousMaterialsDetail"] = sample.HazardousMaterialsDetail
      _sample["MakerID"] = sample.MakerID
      _sample["ModelNumber"] = sample.ModelNumber
      _sample["AnalizeTypeGroup"] = sample.AnalizeTypeGroup
      _sample["AnalizeTypeGroupName"] = sample.AnalizeTypeGroup
      _sample["AnalizeType"] = sample.AnalizeType
      _sample["AnalizeItems"] = sample.AnalizeItems
      _sample["AnalizeSet"] = sample.AnalizeSet

      //分析区分、分析セット名
//      const typelist = this.$store.state.analizeTypeList.filter(item => item.AnalizeTypeGroup  == sample.AnalizeTypeGroup)
      const typelist = this.analizeTypeList.filter(item => item.AnalizeTypeGroup  == sample.AnalizeTypeGroup)
      const AnalizeTypeName = typelist[0].AnalizeTypes.filter(item => item.Value  == sample.AnalizeType)
//      const AnalizeSetByTypes = this.$store.state.analizeSetList.filter(item => item.AnalizeType  == sample.AnalizeType)
      const AnalizeSetByTypes = this.analizeSetList.filter(item => item.AnalizeType  == sample.AnalizeType)
      if (AnalizeSetByTypes[0]) {
        const AnalizeSetByType = AnalizeSetByTypes[0].AnalizeSets
        const AnalizeSetName = AnalizeSetByType.filter(item => item.Value  == sample.AnalizeSet)
        if (AnalizeTypeName[0]) { _sample["AnalizeTypeName"] = AnalizeTypeName[0].Text }
        if (AnalizeSetName[0]) { _sample["AnalizeSetName"] = AnalizeSetName[0].Text }
      }

      //サンプルの分析項目表示用の編集処理
      if (sample.AnalizeItems && sample.AnalizeItems != '""' ) {
        var jsonItems = JSON.parse(sample.AnalizeItems)
        var AnalizeItemName = ""
        var AnalizeItemNameJSON = []
        for (var value in jsonItems) {
//          const AnalizeItembyTypes = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == sample.AnalizeType)
          const AnalizeItembyTypes = this.analizeItemList.filter(item => item.AnalizeType  == sample.AnalizeType)
          if (AnalizeItembyTypes[0]) {
            const AnalizeItembyType = AnalizeItembyTypes[0].AnalizeItems
            const AnalizeItemNames = AnalizeItembyType.filter(item => item.Value == jsonItems[value])
            if(AnalizeItemNames[0]) {
              AnalizeItemName = AnalizeItemName + ',' + AnalizeItemNames[0].Text
              AnalizeItemNameJSON.push({name:AnalizeItemNames[0].Text, value:AnalizeItemNames[0].Value})
            }else{ // 分析項目のデータがなくなった
              AnalizeItemName = AnalizeItemName + ',' + jsonItems[value]
              AnalizeItemNameJSON.push({name:jsonItems[value]})
            }
          }
        }
        _sample["AnalizeItemName"] = AnalizeItemName.slice(1)
        _sample["AnalizeItemNameJSON"] = AnalizeItemNameJSON
      }

      this.selectedSamples.push(_sample)
    },
    delSample(sample) {
      const newArray = this.selectedSamples.filter((item) => { return (item.id != sample.id)})
      this.selectedSamples = newArray
    },
    validation: async function () {
      console.log("click application")
      this.noSaplingAt = false
      this.isSelected = false
      this.invalidOilUsageTimeValue = false
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (this.$v.CustomerOrderNumber.$invalid ||
            this.$v.selectedOffice.$invalid ||
            this.$v.applicationDate.$invalid
        ) {
          console.log("invalid anyone")
          this.showSearch = false
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return
        }
        if(this.$v.selectedSamples.$invalid) {
          console.log("not selected sample")
          this.showSearch = true
          this.$refs.isErrored.open();          
          this.isSelected = true
          this.processing = false
          return
        }
      } else{
        for (const item of this.selectedSamples) {
          if( !item.SamplingAt ) {
            console.log("unset sampling date")
            this.showSearch = false
            this.noSaplingAt = true
            this.$refs.isErrored.open();          
            this.processing = false
            return
          }
          if(item.OilUsageTime) {
            if( item.OilUsageTime.match(/[^0-9]+/)) {      
              console.log("invalid oil usage time")
              this.showSearch = false
              this.invalidOilUsageTimeValue = true
              this.$refs.isErrored.open();          
              this.processing = false
              return
            }
          }
        }
        console.log("valid")
        this.isConfirmed = true
        this.processing = false
      }
    },
    createApplication: async function () {
      console.log("create application")
      this.isConfirmed = false
      this.processing = true

      const Office = this.officeList.filter(item => item.OfficeID  == this.selectedOffice)
      this.selectedOfficeName = Office[0].Name

      //報告書送付先
      //試験依頼番号が99MA9999の場合 00024
      //それ以外の場合 選択した事業所
      let DelvOfficeID = this.selectedOffice
      if(this.CustomerOrderNumber.substr( 2, 2 ) == "MA") {
        DelvOfficeID = this.targetCompanyID + "00024"
      }
      //請求先 00006固定
      let PayOfficeID = this.targetCompanyID + "00006"

      let DelvOffice = this.officeList.filter(item => item.OfficeID  == DelvOfficeID)
      let PayOffice = this.officeList.filter(item => item.OfficeID  == PayOfficeID)

      //Application.idの値を自己生成 形式は4×4
      let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")

      const application = {
        id: uuid,
        OfficeID: Office[0].OfficeID,
        Name: "",
        RepCompanyID: Office[0].CompanyID,
        RepOfficeID: Office[0].OfficeID.substr(10, 5),
//        RepCompany: Office[0].CompanyName,
//        RepOffice: Office[0].Name,
        RepCompany: this.RepCompany,
        RepOffice: "",
        RepDept: "",
        RepPIC: "",
        RepEmployeeID: "",

        DelvCompanyID: DelvOffice[0].CompanyID,
        DelvOfficeID: DelvOffice[0].OfficeID.substr(10, 5),
        DelvCompany: DelvOffice[0].CompanyName,
        DelvOffice: DelvOffice[0].Name,
        DelvDept: "",
        DelvPIC: "",
        DelvType: "",
        DelvEmployeeID: "",
        Observation: "",

        PayCompanyID: PayOffice[0].CompanyID,
        PayOfficeID: PayOffice[0].OfficeID.substr(10, 5),
        PayCompany: PayOffice[0].CompanyName,
        PayOffice: PayOffice[0].Name,
        PayDept: "",
        PayPIC: "",
        PayEmployeeID: "",

        SampleCount: this.selectedSamples.length,
        Price: 0,
        Status: "ご予約中",

        OrdererID: this.$store.state.employee.EmployeeID,
        OrdererCompanyName: this.$store.state.mycompany.Name,
        OrdererOfficeName: this.$store.state.myoffice.Name,
        OrdererName: "ジャパン・アナリスト担当者",

        CustomerOrderNumber: this.CustomerOrderNumber,
        sortKey: new Date().toISOString(),
          Type: "Application"
      }

      application["CustomRepName"] = "01"

      try {
          console.log("this.selectedSamples", this.selectedSamples)
          let applicationDialogIF = {}

          for (const item of this.selectedSamples) {
              let oilUsageTime = null
              if((item.OilUsageTime != null) && (item.OilUsageTime != "")){
                oilUsageTime = item.OilUsageTime
              }

              const sample = {
                id: item.id,
                OfficeID: this.selectedOffice,
                SamplingAt: item.SamplingAt,
                Name: item.Name,
                CustomerMachineID: this.CustomerOrderNumber + ('00' + item.SampleID).slice(-2),
//                CustomerMachineID: item.CustomerMachineID,
                MachineID: item.MachineID,
                MakerID: item.MakerID,
                ModelNumber: item.ModelNumber,
                PurchasedDate: "",
                SystemOil: null,
                SystemOilUnit: "",
                SystemOilUnitText: "",
                MachineMemo: "",
                // ENEOSサンプルは機器使用時間、オイル使用時間に同じ値を設定
                OperatingTime: oilUsageTime,
                OperatingTimeUnit: item.OilUsageTimeUnit,
                OperatingTimeUnitText: item.OilUsageTimeUnitText,
                TotalOperatingTime: null,
                TotalOperatingTimeUnit: "",
                TotalOperatingTimeUnitText: "",
                OilmakerID: item.OilmakerID,
                OilModelNumber: item.OilModelNumber,
                OilTypeCategory: item.OilTypeCategory,
                OilTypeCategoryText: item.OilTypeCategoryText,
                OilType: item.OilType,
                OilTypeText: item.OilTypeText,
                isHazardousMaterials: item.isHazardousMaterials,
                HazardousMaterialsDetail: item.HazardousMaterialsDetail,
                OilChangeDate: "",
                OilChange: null,
                OilChangeUnit: "",
                OilChangeUnitText: "",
                OilUsageTime: oilUsageTime,
                OilUsageTimeUnit: item.OilUsageTimeUnit,
                OilUsageTimeUnitText: item.OilUsageTimeUnitText,
                AnalizeTypeGroup: item.AnalizeTypeGroup,
                AnalizeTypeGroupName: item.AnalizeTypeGroupName,
                AnalizeType: item.AnalizeType,
                AnalizeTypeName: item.AnalizeTypeName,
                AnalizeSet: item.AnalizeSet,
                AnalizeSetName: item.AnalizeSetName,
                AnalizeItems: item.AnalizeItems,
                StandardValue: "0",
                StandardValueName: "",
                Surplus: "0",
                Filter: "001",
                ApplicationID: uuid,
                Memo: item.CustomerMachineID,
                SamplingBy: "",
                BottleCount: 1,
                Price: 0,
                Quantity: 0,
                Status: "10000000",
                HazardousMaterialsConfirmed: "",
                TrackingNumber: item.CustomerMachineID,
                SampleID: ('0000000000' + item.SampleID).slice(-8)
              }
              
              console.log('insert sample', sample)

              const registeredSample = await API.graphql(graphqlOperation(createSample, {input: sample}))
              console.log('success', registeredSample)
//              sampleid = sampleid + 1
//              if(item.isHazardousMaterials == "1") {
//                applicationDialogIF["hasHazardousMaterials"] = true
//              }

          }
          console.log("insert application", application)

          const registeredApplication = await API.graphql(graphqlOperation(createApplication, {input: application}))
          console.log('success', registeredApplication)
          applicationDialogIF["id"] = uuid
          applicationDialogIF["hasHazardousMaterials"] = false

          // this.isSuccessed = true
          window.removeEventListener("beforeunload", this.handler)
          this.isPageMove=true
          this.$refs.isSuccessed.open(applicationDialogIF);
          // this.$router.push('/')
      } catch (error) {
          console.log('error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
      }
    },

    searchMachie : async function () {
      this.loading = true
      this.machines = await fetchAllMachineByOffice(this.selectedOffice)
      this.loading = false
    },
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
</style>
<style scope>
.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: none !important;
  background-color:rgb(235, 232, 232)
}
</style>
